import { css } from 'lit';

export const styles = css`
  :host(:not(:last-child)) > div:not(.barrel-wrapper-closed) {
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  u,
  a {
    text-decoration: underline;
    cursor: pointer;
  }

  ul li {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  .barrel-wrapper {
    margin: 0 calc(-20rem / var(--default-rem-px-count));
    padding: 0 calc(20rem / var(--default-rem-px-count))
      calc(20rem / var(--default-rem-px-count))
      calc(20rem / var(--default-rem-px-count));
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60rem / var(--default-rem-px-count));
    border-top: 2px solid #222222;
    cursor: pointer;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  .inputs:first-child {
    border-top: 1px solid var(--block-rule-color, #c0c0c0);
  }

  .input-row-wrapper {
    width: 100%;
    display: inline-grid;
    grid-template-columns:
      [mat-header]
      30%
      [mat-value]
      auto
      [end];
    grid-template-rows: minmax(0, auto) minmax(0, auto);
    padding-top: calc(24rem / var(--default-rem-px-count));
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    gap: 1.5em 1em;
    border-bottom: 1px solid var(--block-rule-color, #c0c0c0);
  }

  .full-row {
    grid-column: 1 / 3;
    grid-row: 2;
    display: flex;
    flex-direction: column;

    .prompt-content {
      .prompt-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: calc(20rem / var(--default-rem-px-count));
        p {
          font-weight: 500;
        }
      }

      .prompt-body {
        display: flex;
        flex-direction: column;
        gap: calc(14rem / var(--default-rem-px-count));

        .prompt-images {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: calc(20rem / var(--default-rem-px-count));
          padding-bottom: calc(20rem / var(--default-rem-px-count));

          .prompt-image-wrapper > img {
            max-width: 100%;
          }
          .prompt-image-wrapper > :not(:last-child) {
            padding-bottom: calc(14rem / var(--default-rem-px-count));
          }
        }
      }
    }
  }

  .ctas-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    gap: 0 2em;

    cta-button {
      width: calc(220rem / var(--default-rem-px-count));
    }
  }

  .no-border {
    border-bottom: none;
  }

  .input-row-header {
    grid-area: 1 / mat-header;
    display: flex;
    align-items: flex-start;
    gap: calc(5rem / var(--default-rem-px-count));
  }

  .input-row-value {
    grid-area: 1 / mat-value;
  }

  .radio-group {
    display: flex;
    flex-direction: column;
  }

  .input-header {
    display: flex;
    align-items: center;
    gap: calc(10rem / var(--default-rem-px-count));
  }

  .total-price-header,
  .total-price-text {
    font-weight: 500;
    line-height: calc(28rem / var(--default-rem-px-count));
  }

  .total-price-text {
    font-weight: 500;
  }

  .terms-details {
    padding: calc(20rem / var(--default-rem-px-count)) 0;
  }

  .more-info {
    cursor: pointer;
    align-self: flex-start;
    line-height: 1;
  }

  .row-content-text p:not(:last-child) {
    padding-bottom: calc(8rem / var(--default-rem-px-count));
  }

  .radio-inputs {
    display: flex;
    flex-direction: column;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
    width: 4em;
    text-align: center;
  }

  input[type='checkbox'] {
    accent-color: #ff993d;
  }

  /* Radio styles live in choiceStyles (form-controls/choice-styles.js) */

  .questions {
    padding-top: calc(20rem / var(--default-rem-px-count));
    padding-left: calc(30rem / var(--default-rem-px-count));
  }

  .contingecy-text-row {
    padding-top: calc(20rem / var(--default-rem-px-count));
  }

  .terms-label {
    color: inherit;
  }

  .terms-label-alert {
    color: red;
  }

  .text-columns-two {
    column-count: 2;
    column-gap: calc(20rem / var(--default-rem-px-count));
  }

  .trademark-copy {
    padding-top: calc(20rem / var(--default-rem-px-count));
    font-style: italic;
  }

  .chat-prompt {
    margin-top: calc(40rem / var(--default-rem-px-count));
    border-top: 2px solid black;
    padding-top: calc(20rem / var(--default-rem-px-count));
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .input-row-wrapper:not(:last-child) {
      border-bottom: 0.75px solid var(--block-rule-color, #c0c0c0);
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }

    .input-row-wrapper p {
      font-size: 9px;
      letter-spacing: -0.05px;
      line-height: 12px;
    }
  }
`;
